import Vue from 'vue';
import app from '../Webchat/App.vue';
import Router from 'vue-router';
import i18n from '../lang';

import { vstore } from '../store';
import 'bootstrap/dist/css/bootstrap.css';
import bugsnagClient from '@/utilities/bugsnag';

bugsnagClient;


Vue.use(vstore);
Vue.use(Router);
Vue.config.productionTip = false;

const router = new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      component: () => import('./webChat.vue'),
      name:'webChat',
      meta: {
        order: 0
      }
    },
    {
      path: '/productDetails',
      component: () => import('@/views/ProductDetails/ProductDetails.vue'),
      name:'productDetails',
      props:true,
      meta: {
        order: 1
      }
    },
    {
      path: '/map',
      component: () => import('@/views/Map/map.vue'),
      name:'map',
      props:true,
      meta: {
        order: 1
      }
    },
    {
      path: '/itemsList/:id',
      component: () => import('@/views/CategoryList/categoryList.vue'),
      name: 'itemsList',
      props:true
    },
    {
      path: '/cart',
      component: () => import('@/views/OrderCart/orderCart.vue'),
      name: 'cart'
    },
    {
      path: '/webex',
      component: () => import('@/views/Webex/webex.vue'),
      name:'webex',
      props:true,
      meta: {
        order: 1
      }
    },
    {
      path: '/survey',
      component: () => import('@/views/survey.vue'),
      name:'survey',
      props:true,
      meta: {
        order: 1
      }
    },
    {
      path: '/paymentMethods',
      component:  () => import('@/views/PaymentMethods/paymentMethods.vue'),
      name:'paymentMethods',
      props:true,
      meta: {
        order: 1
      }
    },
  ]
});
new Vue({
  i18n,
  router,
  render: h => h(app)
}).$mount('#webchatApp');
